import storage from 'store';
import userApi from '@/api/user';
import depositApi from '@/api/merchantdeposit';

import { ACCESS_TOKEN } from '@/store/mutation-types';

function getLanguage(roles, languages = {}) {
  for (let i = 0; i < roles.length; i++) {
    const el = roles[i];
    if (el.menuGrade < 3) {
      languages[el.menuUrl] = {
        zh: el.menuName,
        vi: el.menuNameVn,
        en: el.menuNameEn
      };
      if (el.childrenMenus && el.childrenMenus.length) {
        getLanguage(el.childrenMenus, languages);
      }
    }
  }
  languages['/welcomes'] = { zh: '欢迎', vi: 'Chào mừng', en: 'welcome' };
  return languages;
}

function clearStorage(commit) {
  commit('SET_USERTYPE', '');
  commit('SET_TOKEN', '');
  commit('SET_CLIENTDATA', {});
  commit('SET_INFO', {});
  commit('SET_ROLES', []);
  commit('SET_PERMISSIONLIST', [], { root: true });
  commit('SET_PERMISSIONAPI', [], { root: true });
  commit('SET_ROUTERS', [], { root: true });
  window.location.reload();
}

const user = {
  state: {
    userType: '',
    info: {},
    token: '',
    roles: [],
    clientdata: {},
    merchantData: {}
  },
  getters: {
    languages({ roles }) {
      return getLanguage(roles);
    }
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
      storage.set(ACCESS_TOKEN, token, 7 * 24 * 60 * 60 * 1000);
    },
    SET_MERCHANTDATA(state, payload) {
      state.merchantData = payload;
    },
    SET_ROLES(state, roles) {
      state.roles = roles;
      storage.set('roles', roles, 7 * 24 * 60 * 60 * 1000);
    },
    SET_USERTYPE(state, userType) {
      storage.set('userType', userType);
      state.userType = userType;
    },
    SET_INFO(state, info) {
      storage.set('info', info);
      state.info = info;
    },
    SET_CLIENTDATA(state, clientdata) {
      const _clientdata = clientdata || {};
      storage.set('clientdata', _clientdata);
      state.clientdata = _clientdata;
    }
  },
  actions: {
    handleLogin({ commit }, params) {
      return new Promise((resolve, reject) => {
        userApi
          .handleLogin(params)
          .then(({ data }) => {
            if (data.data && data.code === 200) {
              commit('SET_TOKEN', data.data.token);
              commit('SET_ROLES', data.data.menuTree);
              commit('SET_USERTYPE', data.data.userType);
              commit('SET_INFO', {
                ...Object.keys(data.data).reduce((acc, curr) => {
                  if (['menuTree', 'token'].indexOf(curr) === -1) {
                    acc[curr] = data.data[curr];
                  }
                  return acc;
                }, {})
              });
              resolve(data);
            } else {
              resolve(data);
            }
          })
          .catch((err) => reject(err));
      });
    },
    loginOut({ commit }) {
      return new Promise((resolve) => {
        userApi
          .handleLogout()
          .then(() => {
            clearStorage(commit);
            // storage.clearAll();
            resolve();
          })
          .catch(() => {
            clearStorage(commit);
            resolve();
          })
          .finally(() => {
            clearStorage(commit);
          });
      });
    },
    getmerchantNo({ commit, state }) {
      return new Promise((resolve, reject) => {
        const params = { merchantNo: state.info.userName };
        depositApi
          .getmerchantNo(params)
          .then(({ data }) => {
            if (data) {
              if (data.code === 200) {
                const merchantData = data.data || {};
                commit('SET_MERCHANTDATA', merchantData);
              } else {
                this.$message.error(data.msg);
              }
            }
            resolve(data);
          })
          .catch((err) => reject(err));
      });
    }
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js